// Team Insights — AI Studio strings (prefix `ins.ai.`)
const en = {
  "ins.ai.free": "Free",
  "ins.ai.invalidType": "Please choose an audio file (WAV, MP3, FLAC, AIFF, M4A, OGG).",
  "ins.ai.tooLarge": "File is too large (max {mb} MB).",
  "ins.ai.duplicate": "You already processed this file with this module.",
  "ins.ai.processAnyway": "Process anyway",
  "ins.ai.emptyResult": "The server returned no result for this file.",
  "ins.ai.playFailed": "Playback failed",
  "ins.ai.downloadFailed": "Download failed",
  "ins.ai.playOriginal": "Play original",
  "ins.ai.original": "Original",
  "ins.ai.processed": "Processed",
  "ins.ai.proTitle": "This is a Pro tool",
  "ins.ai.proDesc": "Upgrade to Pro or Label to unlock stem separation, vocal enhancement, loudness optimization, repair and analysis tools.",
  "ins.ai.upgrade": "Upgrade plan",
  "ins.ai.processingHint": "Processing on our servers — this can take up to a minute for long tracks…",
  "ins.ai.stemsNote": "Stems are created with frequency filtering (bass < 200 Hz, mids, highs, centre channel), not a neural separator.",
  "ins.ai.qualityEstimated": "A heuristic score calculated from your file's level, peak, sample rate and channels. Use it as a guide, not a mastering measurement.",
  "ins.ai.stereo": "Stereo image",
  "ins.ai.noiseFloor": "Noise floor",
  "ins.ai.avgLevel": "Average level",
  "ins.ai.peak": "Peak",
  "ins.ai.sampleRate": "Sample rate",
  "ins.ai.bitDepth": "Bit depth",
  "ins.ai.channels": "Channels",
  "ins.ai.duration": "Duration",
  "ins.ai.readyYes": "Your file passes all distribution checks.",
  "ins.ai.readyNo": "Some checks need attention before distribution.",
  "ins.ai.warning": "Warning",
  "ins.ai.check.loudness": "Loudness",
  "ins.ai.check.format": "Format",
  "ins.ai.check.clipping": "Clipping",
  "ins.ai.check.silence": "Silence",
  "ins.ai.check.duration": "Duration",
  "ins.ai.check.file": "File",
  "ins.ai.historyTitle": "Processing history",
};
const tr = {
  "ins.ai.free": "Ücretsiz",
  "ins.ai.invalidType": "Lütfen bir ses dosyası seçin (WAV, MP3, FLAC, AIFF, M4A, OGG).",
  "ins.ai.tooLarge": "Dosya çok büyük (en fazla {mb} MB).",
  "ins.ai.duplicate": "Bu dosyayı bu modülle zaten işlediniz.",
  "ins.ai.processAnyway": "Yine de işle",
  "ins.ai.emptyResult": "Sunucu bu dosya için sonuç döndürmedi.",
  "ins.ai.playFailed": "Oynatma başarısız",
  "ins.ai.downloadFailed": "İndirme başarısız",
  "ins.ai.playOriginal": "Orijinali dinle",
  "ins.ai.original": "Orijinal",
  "ins.ai.processed": "İşlenmiş",
  "ins.ai.proTitle": "Bu bir Pro araçtır",
  "ins.ai.proDesc": "Stem ayırma, vokal iyileştirme, ses yüksekliği optimizasyonu, onarım ve analiz araçlarını açmak için Pro veya Label planına geçin.",
  "ins.ai.upgrade": "Planı yükselt",
  "ins.ai.processingHint": "Sunucularımızda işleniyor — uzun parçalarda bir dakikayı bulabilir…",
  "ins.ai.stemsNote": "Stem'ler frekans filtreleme ile oluşturulur (bas < 200 Hz, orta, tiz, merkez kanal); sinir ağı tabanlı bir ayırıcı değildir.",
  "ins.ai.qualityEstimated": "Dosyanızın seviye, tepe, örnekleme hızı ve kanal bilgilerinden hesaplanan sezgisel bir puandır. Mastering ölçümü değil, yol gösterici olarak kullanın.",
  "ins.ai.stereo": "Stereo görüntü",
  "ins.ai.noiseFloor": "Gürültü tabanı",
  "ins.ai.avgLevel": "Ortalama seviye",
  "ins.ai.peak": "Tepe",
  "ins.ai.sampleRate": "Örnekleme hızı",
  "ins.ai.bitDepth": "Bit derinliği",
  "ins.ai.channels": "Kanal",
  "ins.ai.duration": "Süre",
  "ins.ai.readyYes": "Dosyanız tüm dağıtım kontrollerinden geçti.",
  "ins.ai.readyNo": "Dağıtımdan önce bazı kontroller dikkat gerektiriyor.",
  "ins.ai.warning": "Uyarı",
  "ins.ai.check.loudness": "Ses yüksekliği",
  "ins.ai.check.format": "Format",
  "ins.ai.check.clipping": "Kırpılma",
  "ins.ai.check.silence": "Sessizlik",
  "ins.ai.check.duration": "Süre",
  "ins.ai.check.file": "Dosya",
  "ins.ai.historyTitle": "İşlem geçmişi",
};
const es = {
  "ins.ai.free": "Gratis",
  "ins.ai.invalidType": "Elige un archivo de audio (WAV, MP3, FLAC, AIFF, M4A, OGG).",
  "ins.ai.tooLarge": "El archivo es demasiado grande (máx. {mb} MB).",
  "ins.ai.duplicate": "Ya procesaste este archivo con este módulo.",
  "ins.ai.processAnyway": "Procesar de todos modos",
  "ins.ai.emptyResult": "El servidor no devolvió ningún resultado para este archivo.",
  "ins.ai.playFailed": "Error de reproducción",
  "ins.ai.downloadFailed": "Error en la descarga",
  "ins.ai.playOriginal": "Reproducir original",
  "ins.ai.original": "Original",
  "ins.ai.processed": "Procesado",
  "ins.ai.proTitle": "Esta es una herramienta Pro",
  "ins.ai.proDesc": "Pásate a Pro o Label para desbloquear separación de stems, mejora vocal, optimización de sonoridad, reparación y análisis.",
  "ins.ai.upgrade": "Mejorar plan",
  "ins.ai.processingHint": "Procesando en nuestros servidores; puede tardar hasta un minuto en pistas largas…",
  "ins.ai.stemsNote": "Los stems se crean con filtrado de frecuencias (graves < 200 Hz, medios, agudos, canal central), no con un separador neuronal.",
  "ins.ai.qualityEstimated": "Puntuación heurística calculada a partir del nivel, pico, frecuencia de muestreo y canales del archivo. Úsala como guía, no como medición de mastering.",
  "ins.ai.stereo": "Imagen estéreo",
  "ins.ai.noiseFloor": "Ruido de fondo",
  "ins.ai.avgLevel": "Nivel medio",
  "ins.ai.peak": "Pico",
  "ins.ai.sampleRate": "Frecuencia de muestreo",
  "ins.ai.bitDepth": "Profundidad de bits",
  "ins.ai.channels": "Canales",
  "ins.ai.duration": "Duración",
  "ins.ai.readyYes": "Tu archivo supera todas las comprobaciones de distribución.",
  "ins.ai.readyNo": "Algunas comprobaciones requieren atención antes de distribuir.",
  "ins.ai.warning": "Aviso",
  "ins.ai.check.loudness": "Sonoridad",
  "ins.ai.check.format": "Formato",
  "ins.ai.check.clipping": "Saturación",
  "ins.ai.check.silence": "Silencio",
  "ins.ai.check.duration": "Duración",
  "ins.ai.check.file": "Archivo",
  "ins.ai.historyTitle": "Historial de procesamiento",
};
export default { en, tr, es };
